<!-- eslint-disable prettier/prettier -->
<template>
  <div v-if="LoaderParameter.isInProgress" class="app__modal app__modal--loader" >
    <div class="container-fluid g-0 app__modalcontainer">
      <div class="row  app__modalrow--loader">
        <div class="col">
          <loader :size="'large'" :type = "'converging-spinner'" />
        </div>
      </div>      
    </div>
  </div>
</template>
<script lang="ts">

import { reactive , defineComponent} from "vue";
import { Loader } from "@progress/kendo-vue-indicators";

export default defineComponent ({
  name: "LoaderPopup",
  props: {
    isInProgress: {
      type: Boolean,
       default: null,
      require: true
    },   
  },
  inheritAttrs: false,
  components: {Loader},
  setup( props) {
    
    const LoaderParameter = reactive({
      isInProgress: props.isInProgress,      
      })

    return {    
      LoaderParameter,      
    };
  }
});
</script>
<style scoped lang="scss">


.app__modal {
  position: fixed;
  margin-left: 40vw;
  margin-top: 20vh;
  height: 20vh;
  width: 20vw;
  border: 1pt, solid, rgb(60, 60, 60);
  border-radius: 12px;
  z-index: 999;
}

.app__modalcontainer {
  height: 100%;
}

.app__modal--loader {
  background-image: linear-gradient(to bottom right, #D7E1EC 0%, #FFFFFF 100%);
}



.app__modalrow--loader {    
  text-align: center!important;
  align-content: center!important;  
  height: 100%;
}



</style>
